import { Check } from 'lucide-react';
import clsx from 'clsx';
import { CHECKLIST_STEPS_BY_MAILBOX } from './invoicingConstants';

const AUTO_STEP_KEYS = new Set(['invoiceNumber', 'complete', 'franklinSentAt', 'cspireSentAt']);

const isStepDone = (call, stepKey) => {
  const checklist = call.billingChecklist || {};
  if (stepKey === 'invoiceNumber') return !!call.invoiceNumber;
  if (stepKey === 'complete') return !!call.isFinalized;
  if (stepKey === 'franklinSentAt' || stepKey === 'cspireSentAt') return !!checklist[stepKey];
  return !!checklist[stepKey];
};

export default function InvoiceStatusBar({ mailbox, call, onToggleManualStep }) {
  const steps = CHECKLIST_STEPS_BY_MAILBOX[mailbox] || [];

  return (
    <div
      className="flex-shrink-0 px-4 py-2 border-t border-surface-border bg-surface-secondary flex items-center gap-4 flex-wrap"
      data-tour-id="invoicing-status-bar"
    >
      <span className="text-2xs font-semibold text-gray-500 uppercase tracking-wide">Status</span>
      {steps.map((step) => {
        const done = isStepDone(call, step.key);
        const isAuto = AUTO_STEP_KEYS.has(step.key);
        const content = (
          <>
            <span
              className={clsx(
                'flex items-center justify-center h-4 w-4 rounded-full border flex-shrink-0',
                done ? 'bg-emerald-500 border-emerald-500 text-white' : 'border-gray-300 text-transparent'
              )}
            >
              <Check className="h-2.5 w-2.5" strokeWidth={3} />
            </span>
            <span className={clsx('text-xs', done ? 'text-gray-800 font-medium' : 'text-gray-500')}>
              {step.label}
            </span>
          </>
        );

        if (isAuto) {
          return (
            <span key={step.key} className="inline-flex items-center gap-1.5" title={isAuto ? 'Updates automatically' : ''}>
              {content}
            </span>
          );
        }

        return (
          <button
            key={step.key}
            type="button"
            onClick={() => onToggleManualStep(step.key, !done)}
            className="inline-flex items-center gap-1.5 hover:opacity-80"
          >
            {content}
          </button>
        );
      })}
    </div>
  );
}
